<kkis-app-webshop-top-section1 (numberWarenkorbItems)="getNumberWarenkorbItems(32)"></kkis-app-webshop-top-section1>

<div id="div_account">
    <button mat-icon-button aria-label="Back to the Shop" (click)="goBack()">
        <mat-icon class="matIcon-md-grey mr-2" [inline]="true">arrow_back</mat-icon>Zurück zum Shop
    </button>
    
    <div id="kundenkonto_head">
        <div class="kk_left" (click)="handleClick($event)">Kundenkonto</div>
        <div class="kk_right" id="kundenkonto_customer">
            <div id="kundenkonto_custno" (click)="handleClick($event)"></div>
            <div id="kundenkonto_customerdata"></div>
        </div>
    </div>    
    
    <div id="kundenkonto_search">
        <div>
            <mat-form-field appearance="fill" style="display: inline">
                <mat-label>Suche</mat-label>
                <input type="text" matInput name="search" [(ngModel)]="search" (keyup)="onKeyup($event)" (keydown.enter)="onSearch()">
                <button matSuffix mat-icon-button (click)="onSearch()"><mat-icon>search</mat-icon></button>
                <button *ngIf="search" matPrefix mat-icon-button aria-label="Clear" (click)="search='';onSearch()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <div id="lief_adr">Lieferadressen:</div><select id="filter_customer"></select>
    </div>

    <div id="div_A" class="receipt_group">
        <div class="receipt_header">
            <div class='head_expand'></div><div>Angebote</div><div class='count'></div>
        </div>
        <div class="receipt_A open"><div class='receipt_header_sub'>Offen</div></div>
        <div class="receipt_A archive"><div class='receipt_header_sub'>Archiv</div></div>
    </div>
    <div id="div_B" class="receipt_group">
        <div class="receipt_header">
            <div class='head_expand'></div><div>Aufträge</div><div class='count'></div>
        </div>
        <div class="receipt_B open"><div class='receipt_header_sub'>Offen</div></div>
        <div class="receipt_B archive"><div class='receipt_header_sub'>Archiv</div></div>
    </div>
    <div id="div_L" class="receipt_group">
        <div class="receipt_header">
            <div class='head_expand'></div><div>Lieferungen</div><div class='count'></div>
        </div>
        <div class="receipt_L open"><div class='receipt_header_sub'>Offen</div></div>
        <div class="receipt_L archive"><div class='receipt_header_sub'>Archiv</div></div>
    </div>

</div>

<!--
<div class="">        
    <div *ngFor="let receipt of receipts" class="">
        <div style="font-weight: bold;">{{receipt.belegNr}}<br></div>
        <div>{{receipt.belegNrZusatz}}<br></div>
    </div>
</div>
-->